import { IFrameResource } from '@lib/iab/iab-vast-model';

interface IIFrameResource {
    _value: string;
}

const createIFrameResource = (
    $iFrameResource: IIFrameResource
): IFrameResource => {
    const res = new IFrameResource();
    res.uri = $iFrameResource._value;
    return res;
};

export default createIFrameResource;
